"use client";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { useRouter } from "next/navigation.js";
export const TableRows = ({ data, columns, anchorBase, anchorKey, onRowClick, }) => {
    const router = useRouter();
    const handleRowClick = (row) => {
        if (onRowClick)
            onRowClick(row);
        if (!anchorBase)
            return;
        if (anchorKey)
            router.push(`${anchorBase}${row[anchorKey]}`);
        else
            router.push(anchorBase);
    };
    const isClickable = !!anchorKey || !!onRowClick;
    return (_jsx("tbody", { className: "divide-y", children: data.map((row, rowIndex) => (_jsx("tr", { className: classNames("text-sm font-normal", {
                "hover:cursor-pointer hover:bg-gray-50": isClickable,
            }), onClick: (e) => {
                e.preventDefault();
                handleRowClick(row);
            }, role: isClickable ? "button" : undefined, tabIndex: isClickable ? 0 : undefined, children: columns.map((column, columnIndex) => (_jsx("td", { className: classNames("p-4", {
                    hidden: column.hidden,
                }), children: _jsx("span", { className: classNames("whitespace-nowrap"), children: _jsx(_Fragment, { children: row[column.key] }) }) }, `cell-${columnIndex}`))) }, `row-${rowIndex}`))) }));
};
